<template>
  <v-text-field
    outlined
    dense
    :disabled="disabled"
    ref="amountInput"
    v-model="model"
    v-currency="options"
    @change="onChange"
    :label="label"
    :hide-details="hideDetails"
  />
</template>
<script>
import { CurrencyDirective, parseCurrency, setValue } from 'vue-currency-input'

export default {
  directives: {
    currency: CurrencyDirective
  },
  props: {
    initAmount: { // IMPORTANT! Its assumed this value is in "cents" or "pennies"
      type: Number,
      default: 0 // ex. 1500 = CA$15.00
    },
    currency: {
      type: String,
      default: 'CAD'
    },
    locale: {
      type: String,
      default: 'en'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Amount'
    }
  },
  watch: {
    'initAmount'(newVal, oldVal) {
      if (newVal !== oldVal && this.el) {
        this.doSetValue(newVal)
      }
    },
    'model'(newVal, oldVal) {
      const newValInt = parseCurrency(newVal, this.options) * 100
      const oldValInt = parseCurrency(oldVal, this.options) * 100
      if (newValInt !== oldValInt) {
        const rounded = Math.round(newValInt)

      }
    }
  },
  mounted() {
    this.el = this.$refs.amountInput.$refs.input

    // its OK when initAmount === 0. Dont need to run anything.
    if (this.initAmount) {
      this.doSetValue(this.initAmount)
    }
  },
  methods: {
    onChange(val) {
      const amount = parseCurrency(this.model, this.options) * 100
      const rounded = Math.round(amount)
      this.$emit('change', rounded)
    },
    doSetValue(value) {
      /**
       * @todo This must account for different currencies in the future
       **/
      setValue(this.el, value / 100)
    }
  },
  data() {
    return {
      model: 0,
      el: null
    }
  },
  computed: {
    options() {
      return {
        locale: this.locale,
        currency: this.currency
      }
    },
    // numberValue() {
    //   /**
    //    * @todo  Expand with new currencies
    //    */
    //   const intVal = parseCurrency(this.model, this.options) * 100
    //   //this.$emit('change', intval)
    //   return intVal
    //
    // }
  }
}
</script>
